import gql from 'graphql-tag';

export default gql`
  fragment preleadCustomizeItemSelectOptionFragment on PreleadCustomizeItemSelectOption {
    id
    clientPreleadCustomizeItemSelectOptionId
  }
`;
